import React, { Component } from 'react';
import styled from 'styled-components';
import { Box } from 'rebass';
import { Wizard } from 'react-albus';

import  { UploadGILabResultsInnerFullPage } from './gutReset/inner/UploadGILabResults';
import { withRouter } from 'react-router-dom';
import withSession from '../lib/withSession';
import { useEffect } from 'react';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
  position: relative;
`;
const UploadGILabResultsPage = ({ history, session }) => {
  // console.log('ugi')
  return (
    <Container>
      <UploadGILabResultsInnerFullPage
        isFullPage
        onSubmitted={() => {
          history.push('/programs/gut-reset');
        }}
      />
    </Container>
  );
};

export default withRouter(withSession(UploadGILabResultsPage));
